import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'SUBSCRIPTION_PLANS_GET',
  GET_ALL_SUCCESS: 'SUBSCRIPTION_PLANS_GET_SUCCESS',
  GET_ALL_FAILURE: 'SUBSCRIPTION_PLANS_GET_FAILURE',
};

export const getAll = actions.getAll(
  query => `${BASE_URL}/payment/subscription-plans/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
